import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "app/containers/Features/containers/TeamSettings/container/Notification/redux/initialState";

const selectDomain = (state: RootState) => state?.notificationSettingsState || initialState;

export const selectNotificationSettings = createSelector(
  [selectDomain],
  (notificationState) => notificationState.settings
);

export const selectIsLoading = createSelector(
  [selectDomain],
  (notificationState) => notificationState.isLoading
);
